import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/router";
import React from "react";
import styles from "./NormalImage.module.scss";
import type { SanityImageObject } from "@sanity/image-url";
import { ResponsiveImage } from "../../../shared/responsiveimage";
export interface NormalImage {
  alt: string;
  image: SanityImageObject;
  caption: string;
  grayscale?: boolean;
}
export const NormalImage: React.FC<NormalImage> = t0 => {
  const $ = _c(11);
  const {
    alt,
    image,
    caption,
    grayscale
  } = t0;
  let classNames;
  if ($[0] !== grayscale) {
    classNames = [styles.wrapper];
    if (grayscale) {
      classNames.push(styles.grayscale);
    }
    $[0] = grayscale;
    $[1] = classNames;
  } else {
    classNames = $[1];
  }
  const t1 = classNames.join(" ");
  let t2;
  if ($[2] !== alt || $[3] !== image) {
    t2 = <ResponsiveImage image={image} alt={alt} layout="responsive" sizes="(min-width: 1521px) 760px, (min-width: 1181px) 640px, (min-width: 845px) 760px, 90vw" />;
    $[2] = alt;
    $[3] = image;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== caption) {
    t3 = <span className="caption">{caption}</span>;
    $[5] = caption;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};